import React from "react";
import { FaHourglassHalf } from "react-icons/fa";
import { Container, Content, Footer, Header } from "./styles/default";
import { Link } from "react-router-dom";

function NotFound() {
	return (
		<Container>
			<Header>
				<img src="eloz-icon-white.svg" alt="Rvops CRM" />
			</Header>
			<Content>
				<div className="feature">
					<FaHourglassHalf className="icon" />
					<h2>Build</h2>
					<p>Ops... The page you are looking for does not exists.</p>
					<Link to="/">Back</Link>
				</div>
			</Content>
			<Footer>
				<p>&copy; 2024 Rvops CRM. All rights reserved.</p>
			</Footer>
		</Container>
	);
}

export { NotFound };
